import { Timestamp } from 'firebase/firestore';

/** Max characters kept on a photo caption. */
export const MAX_PHOTO_CAPTION_LENGTH = 140;

/**
 * A single photo in a plant's gallery.
 *
 * Lives at `users/{uid}/plants/{plantId}/photos/{photoId}`. Exactly one photo
 * per plant has `isPrimary: true` — the "key photo" — and its `url` is mirrored
 * onto the parent plant's `photoURL` field so every existing consumer of
 * `plant.photoURL` keeps working without a subcollection read.
 */
export interface PlantPhoto {
  id: string;
  url: string;
  /**
   * Exact Storage path this photo was uploaded to, so deletion never has to
   * guess it from the download URL. Empty string when there is no object we may
   * delete — a reference photo, or the placeholder.
   */
  storagePath: string;
  isPrimary: boolean;
  caption: string | null;
  createdAt: Timestamp;
}
